@if (isDocumentPage) {
  <div class="body-holder">
    <aside class="sidebar-left" [ngClass]="{ 'd-none d-xl-block': showPdfViewer }">
      <app-document-sidebar-header [hideCurrentUser]="true"></app-document-sidebar-header>
      <div class="sidebar__wrapper">
        <div class="monster__tabs">
          <button type="button" class="tab__item" (click)="changeSidebarContainer('signers')" [ngClass]="{ active: sidebarContainer === 'signers' }">
            <i class="far fa-signature"></i>{{ 'audit.signatories' | translate }}
          </button>

          <button type="button" class="tab__item" (click)="changeSidebarContainer('history')" [ngClass]="{ active: sidebarContainer === 'history' }">
            <i class="far fa-list-ul"></i>{{ 'audit.history' | translate }}
          </button>
        </div>

        @if (sidebarContainer === 'signers') {
          @if (document?.sortable) {
            <p class="sortable-alert"><i class="far fa-info-circle"></i> {{ 'audit.thisDocumentMustBeSignedInSpecificOrder' | translate }}</p>
          }
          <div class="sidebar-signers-list">
            <ng-container [ngTemplateOutlet]="signersTemplate"></ng-container>
          </div>
        }
        <app-document-history-sidebar
          [class.d-none]="sidebarContainer !== 'history'"
          [lockUserData]="document?.configs.lock_user_data"
          [isMarkdownDocument]="documentService.isMarkdownDocument(document)"
          [signersFields]="signersFieldsData"
          #historyComponent
        ></app-document-history-sidebar>
      </div>
    </aside>

    <section class="document" [ngClass]="{ 'showing-extra': isShowingExtra(), 'showing-pdf': showPdfViewer }">
      @if (document) {
        <div class="document-mobile-head">
          <div class="document-mobile-head--logo">
            @if (isWhitelabel()) {
              <img [src]="whitelabelService.whitelabel?.logo" alt="" />
            } @else {
              <a [href]="appService.panelPath('/')">
                <img [src]="whitelabelService.whitelabel?.logo" alt="" />
              </a>
            }
          </div>
          <div class="document-mobile-head--body">
            <div>
              <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
              <div class="document-head-status" [ngClass]="{ signed: documentService.isSigned(document) }">
                <ng-container [ngTemplateOutlet]="documentStatusTemplate"></ng-container>
              </div>
              <div class="document-mobile-head-extra">
                <div class="document-head-extra-mobile">
                  <div class="document-head-extra--column">
                    <a href="javascript:void(0)" class="document-head-extra--column-copy" ngxClipboard [cbContent]="document.hashes.sha2"><i class="far fa-copy"></i></a>
                    <div class="document-head-extra--column-title"><i class="far fa-key"></i> {{ 'audit.sha256Hash' | translate }}</div>
                    <div>{{ document.hashes.sha2 }}</div>
                  </div>
                  <div class="document-head-extra--column">
                    <a href="javascript:void(0)" class="document-head-extra--column-copy" ngxClipboard [cbContent]="document.id"><i class="far fa-copy"></i></a>
                    <div class="document-head-extra--column-title"><i class="far fa-file-certificate"></i> {{ 'audit.documentIdentifier' | translate }}</div>
                    <div>{{ document.id }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mobile-tab-menu">
            <div class="mobile-tab-menu__item" [class.active]="activeTab === MobileTab.Options" (click)="setActiveTab(MobileTab.Options)">
              <i class="far fa-cog"></i> {{ 'audit.options' | translate }}
            </div>
            <div class="mobile-tab-menu__item" [class.active]="activeTab === MobileTab.Signers" (click)="setActiveTab(MobileTab.Signers)">
              <i class="far fa-signature"></i> {{ 'audit.signatories' | translate }}
            </div>
            <div class="mobile-tab-menu__item" [class.active]="activeTab === MobileTab.Document" (click)="setActiveTab(MobileTab.Document)">
              <i class="far fa-file"></i> {{ 'audit.document' | translate }}
            </div>
            <div class="mobile-tab-menu__item" [class.active]="activeTab === MobileTab.History" (click)="setActiveTab(MobileTab.History)">
              <i class="far fa-list"></i> {{ 'audit.history' | translate }}
            </div>
          </div>
        </div>
      }

      @if (document?.is_blocked) {
        <div class="document-warning">
          <div class="document-warning-title"><i class="far fa-exclamation-triangle"></i>&nbsp; {{ 'audit.securityNotice' | translate }}</div>
          <div class="document-warning-descr">
            {{ 'audit.thisDocumentHasBeenBlockedDueToFraudSuspicion' | translate }}<br />
            {{ 'audit.forMoreInformationContactUsAt' | translate }} <a href="mailto:contato@autentique.com.br">contato&#64;autentique.com.br</a>
          </div>
        </div>
      }
      @if (document?.sandbox) {
        <div class="document-sandbox">
          <div class="document-sandbox-title">{{ 'audit.sandboxTestDocument' | translate }}</div>
          <div class="document-sandbox-descr">{{ 'audit.thisDocumentWasCreatedAsASandboxTestAndHasNoLegalValue' | translate }}</div>
        </div>
      }

      @if (document) {
        <div class="document-head">
          <a href="javascript:void(0)" class="document-head-pdf-back d-none" [ngClass]="{ 'd-inline-block d-xl-none': showPdfViewer }" (click)="goBack()">
            <i class="far fa-chevron-left"></i> {{ 'button.back' | translate }}
          </a>
          <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
          <div class="document-head-status" [ngClass]="{ signed: documentService.isSigned(document), 'd-none d-xl-flex': showPdfViewer }">
            <ng-container [ngTemplateOutlet]="documentStatusTemplate"></ng-container>
          </div>
          <div class="document-head-extra" [ngClass]="{ 'd-none d-xl-flex': showPdfViewer }">
            <div class="document-head-extra--column">
              <a href="javascript:void(0)" class="document-head-extra--column-copy" ngxClipboard [cbContent]="document.hashes.sha2"><i class="far fa-copy"></i></a>
              <div class="document-head-extra--column-title"><i class="far fa-key"></i> {{ 'audit.sha256Hash' | translate }}</div>
              <div>{{ document.hashes.sha2 }}</div>
            </div>
            <div class="document-head-extra--column">
              <a href="javascript:void(0)" class="document-head-extra--column-copy" ngxClipboard [cbContent]="document.id"><i class="far fa-copy"></i></a>
              <div class="document-head-extra--column-title"><i class="far fa-file-certificate"></i> {{ 'audit.documentIdentifier' | translate }}</div>
              <div>{{ document.id }}</div>
            </div>
          </div>
        </div>
      }

      @if (!document?.is_dynamic_document && !documentService.isMarkdownDocument(document)) {
        <app-pdf-viewer
          [pdfUrl]="!documentService.isPastLifecycle(document) && document?.files?.original"
          [qualified]="document?.qualified"
          [isNewSignatureStyle]="document?.new_signature_style"
          [documentFooter]="document?.new_signature_style && document?.footer"
          [documentFooterType]="document?.new_signature_style && document?.footer_type"
          [floatingFields]="floatingFields"
          [documentWhitelabel]="documentWhitelabel"
          [isDocumentWhitelabelLoaded]="isDocumentWhitelabelLoaded"
          [document]="document"
          [ngClass]="{ 'd-none d-xl-block': !showPdfViewer && !documentService.isPastLifecycle(document) }"
          [ngStyle]="documentService.isPastLifecycle(document) ? { display: 'none' } : {}"
          #pdfViewer
        ></app-pdf-viewer>
      } @else if (document?.is_dynamic_document) {
        <app-dynamic-document-viewer
          #renderedTemplate
          [content]="documentHTML"
          [theme]="dynamicDocumentTheme || DynamicTemplateThemeEnum.Modern"
          [alreadyFilledFields]="alreadyFilledFields"
          [scale]="renderedDocumentScale"
          [context]="InlineFieldContext.FillSigner"
          (recalculateScale)="updateRenderedDocumentScale()"
          [ngClass]="{ 'd-none d-xl-block': !showPdfViewer && !documentService.isPastLifecycle(document) }"
        ></app-dynamic-document-viewer>
      } @else if (documentService.isMarkdownDocument(document)) {
        <app-markdown-handler [ngClass]="{ 'd-none d-xl-block': !showPdfViewer && !documentService.isPastLifecycle(document) }" [markdownUrl]="document?.files.original"> </app-markdown-handler>
      }

      @if (documentService.isPastLifecycle(document)) {
        <app-document-lifecycle-warning [(document)]="document" [ngClass]="{ 'd-none d-xl-block': !showPdfViewer }"></app-document-lifecycle-warning>
      }

      <div class="sidebar-right-title d-none d-lg-block d-xl-none pl-2 mb-1">{{ 'audit.options' | translate }}</div>
      <div class="document-options d-xl-none" [ngClass]="{ 'd-none': isShowingExtra(), 'd-lg-flex': !showPdfViewer }">
        <ng-container [ngTemplateOutlet]="optionsTemplate"></ng-container>
      </div>
      <div class="p-2 d-lg-none" [ngClass]="{ 'd-none': !showSigners }">
        <ng-container [ngTemplateOutlet]="signersTemplate"></ng-container>
      </div>
      <div class="p-2 d-lg-none" [ngClass]="{ 'd-none': !showHistory }">
        <app-document-history-sidebar
          [lockUserData]="document?.configs.lock_user_data"
          [isMarkdownDocument]="documentService.isMarkdownDocument(document)"
          [signersFields]="signersFieldsData"
          #historyComponentMobile
        ></app-document-history-sidebar>
      </div>
    </section>
    <aside class="sidebar-right">
      <div class="sidebar-right-wrapper">
        <div class="sidebar-right-title">{{ 'audit.options' | translate }}</div>
        <ng-container [ngTemplateOutlet]="optionsTemplate"></ng-container>
      </div>
    </aside>
  </div>
} @else {
  <div class="verification-holder">
    <form class="verification-form" [formGroup]="verificationForm" (ngSubmit)="verify()" novalidate>
      <div class="verification__head"><img class="verification__logo" [src]="whitelabelService.whitelabel?.logo" alt="" /></div>
      <p class="verification__title">{{ 'audit.biometricVerification' | translate }}</p>
      <p class="verification__description">{{ 'audit.enterYourCodeInTheFieldBelowToStartYourVerification' | translate }}</p>

      <label class="field__holder" [appFormControlWrap]="verificationForm.get('code')">
        <input
          type="text"
          class="field"
          formControlName="code"
          name="code"
          autocomplete="none"
          role="presentation"
          autocorrect="off"
          spellcheck="false"
          (input)="setUppercase(verificationForm.get('code'))"
          required
        />
        <span class="field__placeholder">{{ 'audit.code' | translate }}</span>
      </label>
      <div class="centermodal__button-group mt-5">
        <button type="button" class="centermodal__button d-none"></button>
        <button type="submit" class="centermodal__button centermodal__button--custom-next" [disabled]="isLoading || verificationForm.invalid">{{ 'button.forward' | translate }}</button>
      </div>
    </form>
  </div>
}

<ng-template #titleTemplate>
  <h2 class="document-head-name">{{ document.name }}</h2>
  <p class="document-head-date">
    {{ 'audit.createdAt' | translate }} {{ document.created_at | dateTime: createdAtDateFormat : createdAtTimeFormat }}
    @if (document.expiration_at) {
      <span>({{ documentService.isExpired(document) ? ('audit.expired' | translate) : ('audit.expires' | translate) }} {{ document.expiration_at | dateTime }})</span>
    }
  </p>
</ng-template>

<ng-template #documentStatusTemplate>
  <i class="{{ documentService.isSigned(document) ? 'fas fa-check-square' : 'fas fa-exclamation-square' }}"></i>
  {{ 'audit.signedBy' | translate }} <strong>{{ (document.signatures | filterSignedSigners).length }}</strong> {{ 'audit.of' | translate }}
  <strong>{{ ({ signers: document.signatures } | filterSigners)?.length }}</strong>
  {{ 'audit.' + (({ signers: document.signatures } | filterSigners)?.length === 1 ? 'signatory' : 'signatories') | translate | lowercase }}
</ng-template>

<ng-template #signersTemplate>
  @for (signer of document?.signatures; track $index) {
    <div
      class="sidebar-left-signers-item"
      [class.pending]="document.sortable && $index > documentService.getNextSignerIndex(document)"
      [class.to-sign-target]="document.sortable && documentService.isSignerTurn(document, signer)"
    >
      @if (document.sortable) {
        <div class="sidebar-left-signers-order">
          <div class="sidebar-left-signers-order--num">{{ $index + 1 }}</div>
        </div>
      }
      <app-signer-card
        [signer]="signer"
        [sortable]="document.sortable"
        [isSignerTurn]="documentService.isSignerTurn(document, signer)"
        [documentAuthorId]="document.author.id"
        [forceAvatar]="document?.signatures.length > 20"
        [isMarkdownDocument]="documentService.isMarkdownDocument(document)"
        [hideBirthdate]="document.ignore_birthdate"
        [hideCPF]="document.ignore_cpf"
        [isDynamicDocument]="document.is_dynamic_document"
        [isCountryBR]="document?.locale?.country === 'BR'"
        (verifyBiometryClick)="openVerificationDataModal($event)"
      ></app-signer-card>
    </div>
  }
</ng-template>

<ng-template #optionsTemplate>
  @if (document) {
    @if (!documentService.isPastLifecycle(document)) {
      @if (!document.qualified) {
        <ng-container [ngTemplateOutlet]="downloadPrint"></ng-container>
        <span [ngbTooltip]="'audit.tooltipNotSignedYet' | translate" [disableTooltip]="documentService.isSignedOnce(document)" placement="left" container="body">
          <a class="menu-option" target="_blank" [href]="document?.files?.certified" [class.disabled]="!documentService.isSignedOnce(document)">
            <div class="menu-option--icon"><i class="far fa-file-certificate"></i></div>
            <div class="menu-option--body">
              <div class="menu-option--body-title">{{ 'audit.downloadSealedPDF' | translate }}</div>
              <div>{{ 'audit.sealedPDFDescription' | translate }}</div>
            </div>
          </a>
        </span>
      }
      @if (hasQualifiedSignature()) {
        <span [ngbTooltip]="'audit.tooltipNotSignedYet' | translate" [disableTooltip]="documentService.isSignedOnce(document)" placement="left" container="body">
          <a class="menu-option" target="_blank" [href]="documentService.padesDocumentUrl(document)" [class.disabled]="!documentService.isSignedOnce(document)">
            <div class="menu-option--icon"><i class="far fa-file-code"></i></div>
            <div class="menu-option--body">
              <div class="menu-option--body-title">{{ 'audit.downloadPAdESFile' | translate }}</div>
              <div>{{ 'audit.fileSignedWithEachSignatoryCertificatesInPAdESFormat' | translate }}</div>
            </div>
          </a>
        </span>
      }
      @if (document.qualified) {
        <ng-container [ngTemplateOutlet]="downloadPrint"></ng-container>
      }
      <a class="menu-option" href="javascript:void(0)" (click)="documentService.downloadFile(document)" [class.disabled]="!document.files?.original">
        <div class="menu-option--icon"><i class="far fa-file-alt"></i></div>
        <div class="menu-option--body">
          <div class="menu-option--body-title">{{ 'audit.downloadOriginalFile' | translate }}</div>
          <div>{{ 'audit.fileSentForSignatureWithNoChangesOrSignatures' | translate }}</div>
        </div>
      </a>
    }
    @if (appService.isAutentiqueDomain()) {
      <a class="menu-option" [href]="appService.panelPath('/documentos/' + document?.id)" target="_blank">
        <div class="menu-option--icon"><i class="far fa-external-link"></i></div>
        <div class="menu-option--body">
          <div class="menu-option--body-title">{{ 'audit.accessDocument' | translate }}</div>
          <div>{{ 'audit.accessPageInAutentiqueDashboard' | translate }}</div>
        </div>
      </a>
    }
    @if (hasQualifiedSignature()) {
      <span [ngbTooltip]="'audit.tooltipNotSignedYet' | translate" [disableTooltip]="documentService.isSignedOnce(document)" placement="left" container="body">
        <a class="menu-option" href="javascript:void(0)" (click)="openGovbrValidateModal()" [class.disabled]="!documentService.isSignedOnce(document)">
          <div class="menu-option--icon"><i class="far fa-shield-check"></i></div>
          <div class="menu-option--body">
            <div class="menu-option--body-title">{{ 'audit.validateOnGovBr' | translate }}</div>
            <div>{{ 'audit.validateQualifiedSignaturesOnGovBr' | translate }}</div>
          </div>
        </a>
      </span>
    }
  }
</ng-template>

<ng-template #downloadPrint>
  <span [ngbTooltip]="'audit.tooltipNotSignedYet' | translate" [disableTooltip]="documentService.isSignedOnce(document)" placement="left" container="body">
    <a class="menu-option" target="_blank" [href]="documentService.signedDocumentUrl(document)" [class.disabled]="!documentService.isSignedOnce(document)">
      <div class="menu-option--icon">
        <i [class]="hasQualifiedSignature() ? 'far fa-print' : 'far fa-file-contract'"></i>
      </div>
      <div class="menu-option--body">
        <div class="menu-option--body-title">{{ (hasQualifiedSignature() ? 'audit.downloadPrintPDF' : 'audit.downloadSignedPDF') | translate }}</div>
        <div>{{ (hasQualifiedSignature() ? 'audit.printPDFDescription' : 'audit.PDFWithAnnotationsAndAuditPageAtTheEndOfFile') | translate }}</div>
      </div>
    </a>
  </span>
</ng-template>
